export const illustrationNames = [
  "car_breakdown_cone",
  "car_breakdown_traingle",
  "car_parked",
  "car_parked_ev",
  "car_view_back",
  "car_view_front",
  "car_view_side",
  "car_with_getaround_connect_logo",
  "car_with_getaround_logo",
  "car_with_key_exchange_logo",
  "car_with_sparkles",
  "character_hanging_car_keys",
  "character_in_front_of_car_listing",
  "character_in_jeep",
  "character_inspecting",
  "character_inspecting_car",
  "character_lying_on_top_of_car",
  "character_open_car",
  "character_sitting_on_car_trunk_dollars",
  "character_sitting_on_car_trunk_euros",
  "character_sitting_on_chair_with_computer",
  "character_sitting_on_chair_with_computer_lock",
  "character_walking_away",
  "character_with_car_as_toys",
  "character_with_giant_phone_diamond",
  "character_with_giant_phone_pin",
  "character_with_luggage",
  "character_with_signs",
  "character_with_suitcase",
  "character_with_two_kids",
  "characters_exchanging_keys",
  "characters_exchanging_keys_in_car_with_luggage",
  "characters_in_car_at_parking",
  "check",
  "cityscape",
  "country_side",
  "fuel_pump",
  "getaround_technician",
  "hand_checking_phone",
  "hand_with_car_papers",
  "hand_with_card",
  "hand_with_credit_card",
  "hello",
  "hello_headset",
  "leave_parking",
  "leave_parking_arrow",
  "leave_parking_sign",
  "mail",
  "mileage",
  "moving",
  "phone_bluetooth",
  "phone_car",
  "phone_message",
  "phone_no_network",
  "phone_no_wifi",
  "phone_warning",
  "phone_wifi",
  "street_side_parking",
  "technician_working_on_car",
  "trainstation",
  "two_characters_with_a_dog",
  "two_kids",
  "warning",
]
